import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';

import AgencyMe from './agency.me';
import AgencyDashboard from './agency.dashboard';
import AgencySystem from './agency.system';
import AgencyTransaction from './agency.transaction';
import AgencyOrder from './agency.order';

export default function AgencyIndex() {
  let { slug = 'me' } = useParams();

  switch (slug) {
    case 'me':
      return <AgencyMe />;

    case 'dashboard':
      return <AgencyDashboard />;

    case 'transaction':
      return <AgencyTransaction />;

    case 'order':
      return <AgencyOrder />;

    case 'system':
      return <AgencySystem />;

    default:
      return <Theme404 />;
  }
}

